import React from "react";
import { DropdownButton } from "react-bootstrap";
import { FilterOption } from "common/ui/components/table/FilterOption";
import { MenuItem } from "react-bootstrap";
//--
export class FilterDropdownWithState extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selection: "All" };
    }
    renderItems() {
        const { filters, filterName } = this.props;
        return filters.map((filter, index) => {
            if (filter.divider) {
                return (React.createElement(MenuItem, { divider: true }));
            }
            if (filter.title) {
                return (React.createElement(MenuItem, { eventKey: index, key: index, header: true }, filter.title));
            }
            return (React.createElement(FilterOption, { key: index, keyName: filter.keyName, filterCallback: () => {
                    globalFilterHack[filterName] = filter.filterText.toLowerCase();
                    if (!globalFilterInputHack || !globalFilterInputHack.value || globalFilterInputHack.value == "") {
                        globalFilterInputContainerHack.searchChangeHack(" ");
                    }
                    else {
                        globalFilterInputContainerHack.searchChangeHack(globalFilterInputHack.value);
                    }
                    this.setState({ selection: filter.displayName });
                }, displayName: filter.displayName }));
        });
    }
    render() {
        return (React.createElement(DropdownButton, { title: this.state.selection, id: "listingTypeDropdown", className: "griddleColumnFilter", bsSize: "small", onClick: (e) => e.stopPropagation() }, this.renderItems()));
    }
}
